import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group col-sm-12" }
const _hoisted_8 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_11 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_15 = { class: "col p-0" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "form-group mb-2 col" }
const _hoisted_18 = { class: "col-auto p-0 text-end" }
const _hoisted_19 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_20 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_21 = { class: "col p-0" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "form-group mb-2 col" }
const _hoisted_27 = { class: "col-auto p-0 text-end" }
const _hoisted_28 = { class: "col-sm-12" }
const _hoisted_29 = { class: "card card-body" }
const _hoisted_30 = { class: "overflow-auto" }
const _hoisted_31 = {
  key: 0,
  class: "table table-striped border-light align-middle text-left text-nowrap position-relative"
}
const _hoisted_32 = { class: "text-capitalize-first" }
const _hoisted_33 = { class: "text-capitalize-first" }
const _hoisted_34 = { class: "text-capitalize-first" }
const _hoisted_35 = { class: "text-capitalize-first" }
const _hoisted_36 = { class: "text-capitalize-first" }
const _hoisted_37 = { class: "text-capitalize-first" }
const _hoisted_38 = { key: 9 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "text-secondary" }
const _hoisted_41 = {
  key: 1,
  class: ""
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 1,
  class: "table table-striped border-light align-middle text-left text-nowrap position-relative"
}
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = { class: "text-capitalize-first" }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { class: "text-capitalize-first" }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { class: "text-capitalize-first" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_TgUserChangeRuleDescription = _resolveComponent("TgUserChangeRuleDescription")!
  const _component_PayInCanceledDealsCountCheckDescription = _resolveComponent("PayInCanceledDealsCountCheckDescription")!
  const _component_UZSPayInCanceledDealsCountCheckDescription = _resolveComponent("UZSPayInCanceledDealsCountCheckDescription")!
  const _component_PayInCanceledDealsCheckDescription = _resolveComponent("PayInCanceledDealsCheckDescription")!
  const _component_PayOutCompletedDealsCheckDescription = _resolveComponent("PayOutCompletedDealsCheckDescription")!
  const _component_PayOutReceiptVerificationDescription = _resolveComponent("PayOutReceiptVerificationDescription")!
  const _component_RequisitesDeviceChangeCheckDescription = _resolveComponent("RequisitesDeviceChangeCheckDescription")!
  const _component_ActiveDisputesCountCheckDescription = _resolveComponent("ActiveDisputesCountCheckDescription")!
  const _component_PayOutStopScamReceiptCheckDescription = _resolveComponent("PayOutStopScamReceiptCheckDescription")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ReceiptVerificationModal = _resolveComponent("ReceiptVerificationModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab,
                          class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.selectTab(value)), ["prevent"]),
                            class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === value}])
                          }, _toDisplayString(_ctx.helper.trans(`labels.${value}`)), 11, _hoisted_9)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.activeTabName === _ctx.Tabs.traders)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_Multiselect, {
                              id: "traderStatuses",
                              class: "multiselect-sm",
                              modelValue: _ctx.requestDTO.statuses,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                              options: Object.values(_ctx.AntiFraudAlertStatus),
                              "custom-label": (opt) => _ctx.helper.trans(`antifraudalerts.status.${opt}`),
                              multiple: true,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.status')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_TraderMultiselect, {
                              multiple: true,
                              modelValue: _ctx.tradersFilter,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tradersFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => _ctx.receiptVerification(), ["prevent"])),
                            class: "btn btn-outline-dark btn-sm rounded-pill me-4 text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('labels.receipt_verification')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                            class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                            class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.activeTabName === _ctx.Tabs.merchants)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_Multiselect, {
                              id: "merchantBanStatus",
                              class: "multiselect-sm",
                              modelValue: _ctx.merchantBanRequestDTO.status,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.merchantBanRequestDTO.status) = $event)),
                              options: _ctx.merchantBanStatusOptions,
                              "custom-label": (opt) => _ctx.helper.trans(`labels.${opt}`),
                              multiple: false,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.status')
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_Multiselect, {
                              id: "merchantBanFilter",
                              class: "multiselect-sm",
                              modelValue: _ctx.merchantBanFilter,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.merchantBanFilter) = $event)),
                              options: _ctx.merchants,
                              "custom-label": (opt) => `${opt.name} (${opt.email})`,
                              "custom-value": (opt) => opt.id,
                              multiple: false,
                              "select-label": "Select",
                              placeholder: _ctx.helper.trans('labels.merchant'),
                              searchable: true,
                              "internal-search": true,
                              "clear-on-select": false,
                              "close-on-select": true,
                              "options-limit": 100,
                              limit: 1000,
                              "show-no-results": false,
                              "hide-selected": false,
                              onSearchChange: _ctx.asyncFindMerchants,
                              loading: _ctx.isMerchantsSelectLoading
                            }, null, 8, ["modelValue", "options", "custom-label", "custom-value", "placeholder", "onSearchChange", "loading"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => _ctx.applyMerchantBanFilters(), ["prevent"])),
                            class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => _ctx.clearMerchantBanFilters(), ["prevent"])),
                            class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.activeTabName === _ctx.Tabs.traders)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_31, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                            _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                            _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.rule')), 1),
                            _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.helper.trans('labels.trader')), 1),
                            _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                            _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.helper.trans('labels.reviewed')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.id,
                              class: ""
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.id), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1),
                              _createElementVNode("td", null, [
                                (item.rule === _ctx.AntiFraudAlertRule.tg_user_change_rule)
                                  ? (_openBlock(), _createBlock(_component_TgUserChangeRuleDescription, {
                                      key: 0,
                                      alert: item
                                    }, null, 8, ["alert"]))
                                  : (item.rule === _ctx.AntiFraudAlertRule.pay_in_canceled_deals_count_check)
                                    ? (_openBlock(), _createBlock(_component_PayInCanceledDealsCountCheckDescription, {
                                        key: 1,
                                        alert: item
                                      }, null, 8, ["alert"]))
                                    : (item.rule === _ctx.AntiFraudAlertRule.uzs_pay_in_canceled_deals_count_check)
                                      ? (_openBlock(), _createBlock(_component_UZSPayInCanceledDealsCountCheckDescription, {
                                          key: 2,
                                          alert: item
                                        }, null, 8, ["alert"]))
                                      : (item.rule === _ctx.AntiFraudAlertRule.pay_in_canceled_deals_check)
                                        ? (_openBlock(), _createBlock(_component_PayInCanceledDealsCheckDescription, {
                                            key: 3,
                                            alert: item
                                          }, null, 8, ["alert"]))
                                        : (item.rule === _ctx.AntiFraudAlertRule.pay_out_completed_deals_check)
                                          ? (_openBlock(), _createBlock(_component_PayOutCompletedDealsCheckDescription, {
                                              key: 4,
                                              alert: item
                                            }, null, 8, ["alert"]))
                                          : (item.rule === _ctx.AntiFraudAlertRule.pay_out_receipt_verification_rule)
                                            ? (_openBlock(), _createBlock(_component_PayOutReceiptVerificationDescription, {
                                                key: 5,
                                                alert: item
                                              }, null, 8, ["alert"]))
                                            : (item.rule === _ctx.AntiFraudAlertRule.requisite_device_change_rule)
                                              ? (_openBlock(), _createBlock(_component_RequisitesDeviceChangeCheckDescription, {
                                                  key: 6,
                                                  alert: item
                                                }, null, 8, ["alert"]))
                                              : (item.rule === _ctx.AntiFraudAlertRule.active_disputes_count_check)
                                                ? (_openBlock(), _createBlock(_component_ActiveDisputesCountCheckDescription, {
                                                    key: 7,
                                                    alert: item
                                                  }, null, 8, ["alert"]))
                                                : (item.rule === _ctx.AntiFraudAlertRule.pay_out_stopscam_receipt_check)
                                                  ? (_openBlock(), _createBlock(_component_PayOutStopScamReceiptCheckDescription, {
                                                      key: 8,
                                                      alert: item
                                                    }, null, 8, ["alert"]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.helper.trans(`antifraudalerts.rule.${item.rule}`)), 1))
                              ]),
                              _createElementVNode("td", null, [
                                (item.trader)
                                  ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                      key: 0,
                                      user: item.trader
                                    }, null, 8, ["user"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`antifraudalerts.status.${item.status}`)), 1),
                              _createElementVNode("td", null, [
                                (item.reviewedBy)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createVNode(_component_UserNameLabel, {
                                        "show-badge": "",
                                        user: item.reviewedBy
                                      }, null, 8, ["user"]),
                                      _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.dateHelper.format(item.reviewedAt)), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      (item.status === _ctx.AntiFraudAlertStatus.NEW)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: ($event: any) => (_ctx.markAsReviewed(item)),
                                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                          }, [
                                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-check" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.reviewed')), 1)
                                          ], 8, _hoisted_42))
                                        : _createCommentVNode("", true)
                                    ]))
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabName === _ctx.Tabs.merchants)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                            _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.user')), 1),
                            _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.helper.trans('labels.store')), 1),
                            _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.helper.trans('labels.merchant')), 1),
                            _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.helper.trans('labels.ban_date')), 1),
                            _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.helper.trans('labels.expires_at')), 1),
                            _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.helper.trans('labels.actions')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.merchantBanResponse.items, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.id,
                              class: ""
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.id), 1),
                              _createElementVNode("td", null, _toDisplayString(item.userId), 1),
                              _createElementVNode("td", null, _toDisplayString(item.storeName), 1),
                              _createElementVNode("td", null, _toDisplayString(item.merchantName), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.getMerchantBanStatusClass(item.status))
                                }, _toDisplayString(_ctx.helper.trans(`labels.${item.status}`)), 3)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.bannedAt)), 1),
                              _createElementVNode("td", null, _toDisplayString(item.expiresAt == null ? _ctx.helper.trans('labels.permanent') : _ctx.dateHelper.format(item.expiresAt)), 1),
                              _createElementVNode("td", null, [
                                (item.isActive && !item.isExpired)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.unbanMerchantUser(item)),
                                      class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize"
                                    }, [
                                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-unlock" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.unban_user')), 1)
                                    ], 8, _hoisted_52))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(item.isExpired ? _ctx.helper.trans('labels.expired') : _ctx.helper.trans('labels.unbanned')), 1))
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabName === _ctx.Tabs.traders && _ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 2,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[10] || (_cache[10] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabName === _ctx.Tabs.merchants && _ctx.merchantBanResponse.totalCount > _ctx.merchantBanResponse.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 3,
                        modelValue: _ctx.merchantBanPage,
                        "onUpdate:modelValue": [
                          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.merchantBanPage) = $event)),
                          _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadMerchantBans()))
                        ],
                        "total-rows": _ctx.merchantBanResponse.totalCount,
                        "per-page": _ctx.merchantBanResponse.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ReceiptVerificationModal, { ref: "receiptVerificationModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}